import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { pdfStyles } from '../../..';
import { InvoiceInterface } from '../../../../interfaces/invoice.interface';
import { PAYMENT_METHOD_AADE_CODE } from '../../../../interfaces/paymentTypes.interface';

interface Props {
  doc: InvoiceInterface;
}

export const PdfNotes = ({ doc }: Props) => {
  const { t } = useTranslation();

  const getPosTransactionDetails = useCallback(() => {
    if (
      doc?.post_with_provider &&
      doc?.paymentType?.aadeCode === PAYMENT_METHOD_AADE_CODE.POS &&
      doc?.latestPayment?.posTransactionDetails
    ) {
      return (
        <>
          <Text style={pdfStyles.fontNormal7}>
            {t('PDF.POS_PAYMENT_ID')}: {doc?.latestPayment?.posTransactionDetails?.transactionId}
            {' - '}
            {t('PDF.POS_PAYMENT_SIGNATURE')}: {doc?.latestPayment?.posTransactionDetails?.provider_signature}
          </Text>
        </>
      );
    }
  }, [doc?.latestPayment?.posTransactionDetails, doc?.paymentType?.aadeCode, doc?.post_with_provider, t]);

  return (
    <View style={styles.section}>
      <View style={styles.container}>
        <Text style={pdfStyles.regularTitle}>{t('PDF.NOTES')}</Text>
      </View>
      <View style={styles.notes}>
        <Text style={pdfStyles.body2}>{doc?.notes}</Text>
        {getPosTransactionDetails()}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  section: {
    flexDirection: 'column',
    height: 56,
  },
  container: {
    paddingLeft: 4,
    backgroundColor: '#9d9fa6',
    justifyContent: 'center',
    // alignItems: 'center',
    // textAlign: 'center'
  },
  notes: {
    paddingLeft: 4,
    paddingTop: 4,
  },
});
